import React from "react";

// Experience row: company header, then one dated row per position.
const Bullets = ({ bullets = [] }) =>
  bullets.length ? (
    <ul className="mt-3 flex max-w-prose flex-col gap-2 text-sm leading-relaxed text-muted">
      {bullets.map((bullet) => (
        <li key={bullet} className="flex gap-3">
          <span className="mt-[0.7em] h-px w-3 shrink-0 bg-muted/60" aria-hidden="true" />
          <span>{bullet}</span>
        </li>
      ))}
    </ul>
  ) : null;

// Positions sit on a connected line, newest first.
const PositionsCard = ({ role }) => (
  <article className="py-6">
    <div className="grid gap-2 md:grid-cols-[11rem_1fr] md:gap-8">
      <span aria-hidden="true" />
      <div>
        <h3 className="tint-text text-base font-semibold tracking-tight">{role.company}</h3>
      </div>
    </div>
    <ol className="mt-5 flex flex-col">
      {role.positions.map((position, index) => (
        <li key={position.title} className="grid gap-2 md:grid-cols-[11rem_1fr] md:gap-8">
          <span className="tint-text tabular pt-0.5 font-mono text-[13px]">{position.range}</span>
          <div
            className={`relative border-l border-border pl-6 ${
              index === role.positions.length - 1 ? "" : "pb-6"
            }`}
          >
            <span
              className="absolute -left-[5px] top-[0.4rem] h-[9px] w-[9px] rounded-full"
              style={{ background: "rgb(var(--p, var(--c-accent)))" }}
              aria-hidden="true"
            />
            <h4 className="text-base font-semibold tracking-tight text-text">{position.title}</h4>
            {position.summary ? <p className="mt-1 text-sm text-muted">{position.summary}</p> : null}
            <Bullets bullets={position.bullets} />
          </div>
        </li>
      ))}
    </ol>
    {role.subtitle ? (
      <div className="mt-5 grid gap-2 md:grid-cols-[11rem_1fr] md:gap-8">
        <span aria-hidden="true" />
        <p className="text-sm text-muted">{role.subtitle}</p>
      </div>
    ) : null}
  </article>
);

const RoleCard = ({ role }) => <PositionsCard role={role} />;

export default RoleCard;
